export default "__VITE_ASSET__CQVLxTv3__"